import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/arbitrage-bet-calculator',
  component: () => import('../../routes/ArbitrageBet.svelte'),
  card: {
    id: 'arbitrage-bet',
    title: 'Arbitrage Betting Calculator',
    description: 'Find guaranteed profit by calculating optimal stakes across opposing outcomes.',
    icon: 'sports',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/arbitrage-bet-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Arbitrage Betting Calculator – Find Guaranteed Profit',
    description: 'Calculate optimal stakes to guarantee profit by betting on all outcomes of an event. Find arbitrage opportunities in sports betting.',
  },
};

export default meta;